// Architectural dimension constants for window and door components
// All dimensions are in inches unless otherwise specified

export const WINDOW_DIMENSIONS = {
  MAX_WIDTH_INCHES: 42,
  FRENCH_DOOR_HEIGHT_INCHES: 81.5,
};

export const STANDARD_SPACING = {
  EIGHT_INCHES: 8,
  FIVE_INCHES: 5,
  TEN_INCHES: 10,
  FIFTEEN_INCHES: 15,
};

export const MATERIAL_LENGTHS_FEET = [8, 10, 12, 14, 16];

export const LENGTH_LOOKUP_TABLE = {
  8: 8,
  9: 10,
  10: 10,
  11: 12,
  12: 12,
  13: 14,
  14: 14,
  15: 16,
  16: 16,
};

export const WINDOW_COLORS = {
  GLASS: "#c2e4f2",
  FRAMING: "lightgrey",
  STROKE: "black",
  TEMPERED_TEXT: "red",
};

export const TEXT_SIZES = {
  SMALL: 80, // Used for header text (divided by pixels)
  MEDIUM: 20, // Used for window type text
};
